import Button from "@mui/material/Button";
import CircularProgress from "@mui/material/CircularProgress";
import { useTransfers } from "./transfers";

/** Shown in the top bar while uploads run, from any page. */
export function UploadIndicator({ onOpen }: { onOpen: () => void }) {
  const { transfers } = useTransfers();
  const active = transfers.filter((t) => !t.error);
  const failed = transfers.length - active.length;
  if (!transfers.length) return null;
  const size = transfers.reduce((n, t) => n + t.size, 0);
  const sent = transfers.reduce((n, t) => n + t.sent, 0);
  const label = active.length
    ? `Uploading ${active.length} file${active.length === 1 ? "" : "s"}`
    : `${failed} upload${failed === 1 ? "" : "s"} interrupted`;
  return (
    <Button
      size="small"
      color={active.length ? "primary" : "warning"}
      onClick={onOpen}
      startIcon={
        <CircularProgress size={16} variant="determinate" value={size ? (100 * sent) / size : 0} aria-hidden />
      }
    >
      {label}
    </Button>
  );
}
